import React, { useState } from "react";
import { Modal, Tooltip } from "antd";
import { ShareAltOutlined } from '@ant-design/icons';
import { ShareModalContent } from "./ShareModalContent/ShareModalContent";
import './ShareModal.css';

/**
 * viewMode="menu" renders the trigger as the given row for the header's
 * compact menu (onMenuClick closes that menu) instead of the Share button;
 * the dialog itself is the same either way.
 */
export const ShareModal = ({ viewMode = 'button', onMenuClick, menuRow }) => {
  const isMobile = window.screen.width < 768;
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [privacy, setPrivacy] = useState(0);
  const [view, setView] = useState("access");

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    setPrivacy(0);
    setView("access");
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setPrivacy(0);
    setView("access");
  };

  const openFromMenu = () => {
    onMenuClick?.();
    showModal();
  };

  return (
    <>
      {viewMode === 'menu' ? (
        <div onClick={openFromMenu} role="menuitem" style={{ width: '100%' }}>
          {menuRow}
        </div>
      ) : (
      <Tooltip title="Share" placement="bottom">
        <button
          onClick={showModal}
          aria-label="Share"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '5px',
            height: '30px',
            padding: isMobile ? '0 10px' : '0 14px',
            background: '#526bb1',
            border: '1px solid #526bb1',
            borderRadius: '6px',
            color: '#ffffff',
            fontSize: '11px',
            fontWeight: 600,
            cursor: 'pointer',
            transition: 'background-color 0.12s ease, border-color 0.12s ease',
            letterSpacing: '0.01em',
            flexShrink: 0,
          }}
          onMouseEnter={e => { e.currentTarget.style.backgroundColor = '#41589a'; e.currentTarget.style.borderColor = '#41589a'; }}
          onMouseLeave={e => { e.currentTarget.style.backgroundColor = '#526bb1'; e.currentTarget.style.borderColor = '#526bb1'; }}
        >
          <ShareAltOutlined style={{ fontSize: '11px' }} />
          {!isMobile && 'Share'}
        </button>
      </Tooltip>
      )}
      <Modal
        title={(
          <div className="share-modal-heading">
            <span className="share-modal-heading__badge">
              <ShareAltOutlined />
            </span>
            <span className="share-modal-heading__text">
              <span className="share-modal-heading__title">Share</span>
              <span className="share-modal-heading__doc">Invite people or share a link</span>
            </span>
          </div>
        )}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={false}
        width={460}
        centered
        destroyOnClose
        className="share-doc-modal"
      >
        <ShareModalContent
          setIsModalVisible={setIsModalVisible}
          privacy={privacy}
          setPrivacy={setPrivacy}
          view={view}
          setView={setView}
        />
      </Modal>
    </>
  );
};
